import styled from "styled-components";

export const CalenderWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px 16px 24px;
  z-index: 1000;
  color: #000;
  border-radius: 38px;
  width: 294px;
  border-radius: 12px;
`;

export const CalenderGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  gap: 2px;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  padding-bottom: 30px;

  > .label {
    margin: 10px 0;
  }

  > .empty {
    color: #fff;
    padding: 10px;
  }
  > .day {
    cursor: pointer;
    color: #a6a6a6;
    width: 35px;
    height: 35px;
    line-height: 35px;
    border-radius: 50%;
    box-sizing: border-box;
    position: relative;

    > .count-wrapper {
      position: absolute;
      top: 5px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 2px;

      > .count {
        background: #ff0000;
        width: 4px;
        height: 4px;
        border-radius: 50%;
      }
    }

    &.select {
      background: #7f25fb;
      color: #fff;
    }

    &.blur {
      color: #3f6262;
      background: #e3f5f5;
    }

    &.today {
      border: 1px solid #a6a6a6;
    }
  }
`;

export const CalenderHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;

  > .title {
    font-weight: 800;
    font-size: 18px;
  }
`;

export const CalenderHeaderDate = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 11.59px;
  display: flex;
  gap: 5px;

  > .date {
    width: 68px;
    text-align: center;
  }

  > .arrow {
    cursor: pointer;

    > img {
      width: 14px;
      height: 14px;
    }
  }
`;

export const CalenderButtonWrapper = styled.div`
  display: flex;
  widht: 100%;
  height: 48px;

  > .button {
    border-radius: 8px;
    flex: 1;
    font-weight: 600;
    font-size: 15px;
    line-height: 48px;
    text-align: center;
    color: #c4c4c4;
  }

  > .purple {
    background: #7f25fb;
    color: #fff;
  }
`;
